import React from 'react';
import Icon from "components/Varios/Icons.js";
import { InputGroup, Input, InputGroupAddon } from 'reactstrap';
import TooltipItem from "components/Varios/Tooltip.js";
import { FileInfo } from 'components/Types/GeneralTypes';

type InputFileUploadProps = {
    name: string,
    icon: string,
    id: string,
    placeholder: string,
    onChange: (archivo: FileInfo) => void,

}

type InputFileUploadState = {
    selectedFileName: string,
    selectedFile: File | null
}





export default class InputFileUpload extends React.Component<InputFileUploadProps, InputFileUploadState> {
    private fileRef: React.RefObject<HTMLInputElement>;
    constructor(props: InputFileUploadProps) {
        super(props);

        this.state = {
            selectedFile: null,
            selectedFileName: this.props.placeholder
            // selectedFileName: this.props.name

        };
        this.fileRef = React.createRef();
    }

    onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event) {
            if (event.target.files && event.target.files.length) {
                const fileToUpload = event.target.files[0];
                this.setState(
                    { selectedFile: fileToUpload, selectedFileName: fileToUpload.name },
                    (
                        () => {
                            this.props.onChange(
                                {
                                    nombreFile: this.props.name, file: fileToUpload, id: this.props.id
                                }
                            )
                        }
                    )
                );
            }
        }

    }



    handleClick = () => {
        const fileInput = this.fileRef.current;
        if (fileInput) {
            fileInput.click();
        }
    }

    render() {
        return (
            <label className="custom-file-upload" style={{ display: "initial" }} >

                <input type="file" accept=".pdf, .p12" onChange={(e) => this.onChange(e)} ref={this.fileRef} />
                <InputGroup>

                    {
                        <Input onClick={this.handleClick} id="inputfile" readOnly type="text" placeholder={this.props.placeholder} value={this.state.selectedFileName ? this.state.selectedFileName : this.props.placeholder} />
                    }
                    <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
                        <Icon kind={this.props.icon} fill='#FFFFFF' width={27} height={27} />
                    </InputGroupAddon>
                </InputGroup>
                <TooltipItem content="Los archivos se subirán al momento de dar clic en el botón Guardar" id="inputfile" />
            </label>
        );
    }
}
